export const BestTimeToCallIcon = ({
   width = 32,
   height = 32,
}: {
   width?: number
   height?: number
}) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
   >
      <g clipPath="url(#clip0_164_942)">
         <path
            d="M16 0.000976562C12.8355 0.000976563 9.74207 0.93936 7.11088 2.69746C4.4797 4.45557 2.42894 6.95442 1.21793 9.87804C0.00693258 12.8017 -0.309921 16.0187 0.307443 19.1224C0.924806 22.2261 2.44866 25.077 4.6863 27.3147C6.92394 29.5523 9.77487 31.0762 12.8786 31.6935C15.9823 32.3109 19.1993 31.9941 22.1229 30.7831C25.0466 29.5721 27.5454 27.5213 29.3035 24.8901C31.0616 22.2589 32 19.1655 32 16.001C31.9954 11.7589 30.3082 7.69192 27.3087 4.69234C24.3091 1.69275 20.2421 0.00556467 16 0.000976562ZM16 29.3343C13.3629 29.3343 10.7851 28.5523 8.5924 27.0872C6.39975 25.6222 4.69078 23.5398 3.68161 21.1034C2.67245 18.6671 2.4084 15.9862 2.92287 13.3998C3.43734 10.8134 4.70722 8.43759 6.57192 6.57289C8.43662 4.70819 10.8124 3.43831 13.3988 2.92384C15.9852 2.40937 18.6661 2.67341 21.1025 3.68258C23.5388 4.69175 25.6212 6.40072 27.0863 8.59337C28.5514 10.786 29.3333 13.3639 29.3333 16.001C29.3295 19.536 27.9235 22.9251 25.4238 25.4248C22.9242 27.9244 19.535 29.3304 16 29.3343Z"
            fill="white"
         />
         <path
            d="M16.0003 8.00098C15.6466 8.00098 15.3075 8.14145 15.0574 8.3915C14.8074 8.64155 14.6669 8.98069 14.6669 9.33431V15.101L10.1723 17.917C9.87168 18.1048 9.658 18.4042 9.57823 18.7496C9.49847 19.0949 9.55915 19.4577 9.74692 19.7583C9.93469 20.0589 10.2342 20.2726 10.5795 20.3523C10.9248 20.4321 11.2877 20.3714 11.5883 20.1836L16.7083 16.9836C16.9017 16.8624 17.0608 16.6936 17.1703 16.4933C17.2798 16.293 17.336 16.0679 17.3336 15.8396V9.33431C17.3336 8.98069 17.1931 8.64155 16.9431 8.3915C16.693 8.14145 16.3539 8.00098 16.0003 8.00098Z"
            fill="white"
         />
      </g>
      <defs>
         <clipPath id="clip0_164_942">
            <rect
               width="32"
               height="32"
               fill="white"
               transform="translate(0 0.000976562)"
            />
         </clipPath>
      </defs>
   </svg>
)
